module.exports = __webpack_public_path__ + "img/LUB00087.aa0ed059.png";